import React, { useState } from "react";
import styled from "styled-components";
import { FaChevronUp, FaPhoneAlt, FaEnvelope, FaPlus } from "react-icons/fa";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  window.addEventListener("scroll", () => {
    window.pageYOffset > 100 ? setVisible(true) : setVisible(false);
  });

  return (
    <Div>
      {/* Floating Menu Toggle */}
      <MenuButton
        className={`${visible ? "block" : "none"}`}
        onClick={() => setMenuOpen(!menuOpen)}
        isOpen={menuOpen}
      >
        <FaPlus />
      </MenuButton>

      {/* Floating Menu Options */}
      <Menu className={menuOpen ? "open" : ""}>
        <li>
          <a
            href="tel:+6421881444"
            className="vibrate"
            style={{ bottom: "-160px" }}
          >
            <FaPhoneAlt />
          </a>
        </li>
        <li>
          <a
            href="mailto:info@oakmont.co.nz"
            className="vibrate"
            style={{ bottom: "-160px" }}
          >
            <FaEnvelope />
          </a>
        </li>
        <li>
          <a href="#" className="vibrate" style={{ bottom: "-160px" }}>
            <FaChevronUp />
          </a>
        </li>
      </Menu>
    </Div>
  );
}

const Div = styled.div`
  max-width: 100vw;
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 10;

  .none {
    opacity: 0;
    visibility: hidden;
  }

  a {
    background-color: var(--secondary-color);
    padding: 1rem;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.4s ease-in-out;
    color: #fff;
    font-size: 1.5rem;
    margin-bottom: 10px;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    svg {
      font-size: 1.5rem;
    }
  }

  .vibrate {
    animation: vibrate 0.5s linear infinite;
  }

  @keyframes vibrate {
    0%,
    100% {
      transform: translateX(0);
    }
    20% {
      transform: translateX(-2px);
    }
    40% {
      transform: translateX(2px);
    }
    60% {
      transform: translateX(-2px);
    }
    80% {
      transform: translateX(2px);
    }
  }
`;

/* Floating Menu Button */
const MenuButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: var(--secondary-color);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: #fff;
  font-size: 1.2rem;
  z-index: 11;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  svg {
    transition: transform 0.3s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? "rotate(45deg)" : "rotate(0)")};
  }
`;

/* Floating Menu */
const Menu = styled.ul`
  position: fixed;
  bottom: 240px;
  right: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  z-index: 10;

  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  li {
    margin-bottom: 10px;
  }

  a {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--secondary-color);
    color: #fff;
    transition: 0.3s;
    position: relative;

    &:hover {
      background: var(--primary-color);
    }
  }
`;

export default ScrollToTop;
